import React from 'react';

const StudyesContext = React.createContext({
    studyes: [],
    setStudyes: () => { }
})

export default StudyesContext;